import { Analytics } from '@cobliteam/analytics';
import { useGlobalFilterStore, useUser, useVehicle, useVehicleGroup } from '@cobliteam/hooks';
import { useTranslation } from '@cobliteam/i18n';
import { FormControl, FormField, FormItem, FormMessage, Label, useFormContext } from '@cobliteam/ui/form';

import { MultiSelectVehicleGroups, MultiSelectVehicles } from '@cobliteam/ui-business/components';

import type { FormValues } from '../checklistSchema';

const ChecklistVehiclesFilters = () => {
  const { t } = useTranslation('checklists');
  const { control } = useFormContext<FormValues>();

  const { hasGroupsRestriction } = useUser();

  const vehicleGroupIds = useGlobalFilterStore((state) => state.vehicleGroupIds);

  const { data: vehicleGroups = [], isPending: isLoadingVehicleGroups } = useVehicleGroup().getVehicleGroups({}, vehicleGroupIds);
  const { data: vehicles = [], isPending: isLoadingVehicles } = useVehicle().getVehicles({}, vehicleGroupIds);

  return (
    <div>
      <Label>
        {t('send_checklist_to')}
        {hasGroupsRestriction && <span className='text-danger'>*</span>}
      </Label>

      <div className='flex items-center gap-2.5'>
        <FormField control={control} name='vehicleGroupIds'>
          {({ field }) => (
            <FormItem className='flex items-center gap-2.5'>
              <FormControl>
                <MultiSelectVehicleGroups
                  selectedVehicleGroups={vehicleGroups.filter((group) => field.value?.map((id) => id).includes(group.id))}
                  title={!field.value?.length || field.value.length === vehicleGroups.length ? t('all_groups_title') : t('groups_title')}
                  isLoading={isLoadingVehicleGroups}
                  onChange={(value) => {
                    Analytics.track('Checklist Vehicle Group Changed');
                    field.onChange(value.map((v) => v.id));
                  }}
                  onClear={() => field.onChange([])}
                />
              </FormControl>
            </FormItem>
          )}
        </FormField>

        <FormField control={control} name='vehicleIds'>
          {({ field, formState }) => (
            <FormItem>
              <FormControl>
                <MultiSelectVehicles
                  selectedVehicles={vehicles.filter((v) => field.value?.map((id) => id).includes(v.id))}
                  title={!field.value?.length || field.value.length === vehicles.length ? t('all_vehicles_title') : t('vehicles_title')}
                  isLoading={isLoadingVehicles}
                  portal
                  onChange={(value) => {
                    Analytics.track('Checklist Vehicle Changed');
                    field.onChange(value.map((v) => v.id));
                  }}
                  onClear={() => field.onChange([])}
                />
              </FormControl>
              {formState.errors.vehicleIds && <FormMessage />}
            </FormItem>
          )}
        </FormField>
      </div>
    </div>
  );
};

export default ChecklistVehiclesFilters;
